import Programs from './Programs';
import ProgramDetail from './ProgramDetail';
import ProgramEditForm from './ProgramEditForm';

export { ProgramDetail, ProgramEditForm };

export default Programs;
